import React, { FC, useState } from "react";
import { Link } from "react-router";
import { Button, Col, FormGroup, Input, Row } from "reactstrap";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import { toastOptions } from "config/constants";
import accountApi from "api/account";

const ForgotPassword: FC = () => {
  const [email, setEmail] = useState<string>("");
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const submit = async () => {
    if (!email.trim()) {
      toast.error("Enter your email", toastOptions);
      return;
    }
    setIsLoading(true);
    try {
      await accountApi.forgotPassword(email.trim());
      setSubmitted(true);
    } catch (err: any) {
      if (err?.response?.status === 429) {
        // Rate limited: nothing was sent, so say so rather than "check your inbox".
        toast.error(err.response.data?.error ?? "Too many attempts. Please try again later.", toastOptions);
      } else {
        // backend always returns 200 to avoid email enumeration, but
        // swallow other errors here too so we never reveal account state
        setSubmitted(true);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="h-100 bg-plum-plate bg-animation">
      <div className="d-flex h-100 justify-content-center align-items-center">
        <Col md="8" className="mx-auto app-login-box">
          <div className="modal-dialog w-100 mx-auto">
            <div className="modal-content">
              <div className="modal-body">
                <div className="app-logo mx-auto mb-3" />
                <h4 className="text-center mb-3">Forgot password</h4>
                {submitted ? (
                  <p className="text-center">
                    If an account exists for <strong>{email}</strong>, we just sent a password reset link.
                    Check your inbox.
                  </p>
                ) : (
                  <>
                    <p className="text-muted text-center mb-3">
                      Enter your email and we&apos;ll send you a link to reset your password.
                    </p>
                    <Row form>
                      <Col md={12}>
                        <FormGroup>
                          <Input
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") submit();
                            }}
                            type="email"
                            name="email"
                            id="email"
                            placeholder="Email..."
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </>
                )}
              </div>
              <div className="modal-footer clearfix">
                <div className="float-left">
                  <Link to="/signin">Back to sign in</Link>
                </div>
                {!submitted && (
                  <div className="float-right">
                    <Button color="primary" disabled={isLoading} size="lg" onClick={submit}>
                      Send reset link
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Col>
      </div>
      <ToastContainer autoClose={2000} />
    </div>
  );
};

export default ForgotPassword;
